import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="m4.268 2 17.677 17.678-1.768 1.767L2.5 3.768l1.768-1.767Z" />
    <path fill="currentColor" d="M2.5 19.678 20.177 2.001l1.768 1.767L4.267 21.446 2.5 19.677Z" />
  </svg>
);
export default SvgComponent;
